/**
 * Base compartida de los tipos NO-mecánicos (electrical, trenches, evacuación).
 * Hoy los 4 comparten comportamiento; cada perfil solo sobre-escribe lo que cambia
 * (p. ej. screenshotName / codePrefix). Así se evita divergir sin querer.
 *
 * DATA-ONLY (flags + strings): no importa componentes Vue ni toca el engine.
 * CadStudio (el orquestador) resuelve los componentes por estas claves
 * ('select-layers' → SelectLayersModal, 'register-advance' → RegisterAdvanceModal).
 */
export const NON_MECHANICAL_BASE = {
  // Modo DISEÑO (admin: carga + procesa + guarda).
  design: {
    loadFlow:             'select-layers', // Procesar → SelectLayersModal
    requiresProcessing:   false,           // guardar OBLIGA a procesar antes? no (se guarda con el parser)
    generatesBinaryScene: true,            // al guardar sube un .epcb para el viewer cliente
    captureMode:          'snapshot',      // una sola toma
    summaryFields:        [],              // SaveSuccessModal: sin conteos de subdivisión
    screenshotName:       'preview.png',
    codePrefix:           null,
  },
  // Modo AVANCE (cliente: registra progreso).
  progress: {
    linearAdvance: true,                   // AdvanceOverlay + hover + click + modal
    advanceModal:  'register-advance',     // RegisterAdvanceModal
    // Gesto INLINE sobre el canvas (click=inicio A/B, arrastre=sentido+delta,
    // soltar=popover estado/fecha). Cuando está activo el overlay deja de capturar
    // clicks y el gesto maneja el avance (el doble-click → modal queda de fallback).
    inlineAdvance: true,
  },
  // Modal de INFO de capa: estos tipos miden por LONGITUD (metros) → longitud
  // total + longitud por estado. Mismo criterio en diseño y en avance.
  layerInfo: {
    metric: 'length',
  },
}
